// extracted by mini-css-extract-plugin
module.exports = {"Main":"Spinner__Main__28nqi"};